// extracted by mini-css-extract-plugin
export default {"header":"HeadPay_header__SOTip","icon":"HeadPay_icon__OKwpH","color-blue-night-2":"HeadPay_color-blue-night-2__ZB0ev"};